import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAwHgUZ4sKXl9nyLDvkYh-fzhO8ZkLIhSw",
  authDomain: "setsender-54f47.firebaseapp.com",
  projectId: "setsender-54f47",
  storageBucket: "setsender-54f47.firebasestorage.app",
  messagingSenderId: "821371558285",
  appId: "1:821371558285:web:0a28560e8a4d644258c5c4",
  measurementId: "G-5351XMR88F"
};

// Initialize Firebase
initializeApp(firebaseConfig);
